import { DownloadOutlined } from "@ant-design/icons";
import to from "await-to-js";
import React, { useContext } from "react";

import { t } from "i18next";
import FileUploader from "../../../../../../../components/FileUploader/FileUploader";
import { ModalsContext } from "../../../../../../../context/modals.context";
import { ministryService } from "../../../../../../../modules/ministry/ministry.service";
import { IDozvolaZahteviDostavljeniDokaziProps } from "../../../../../../../modules/ministry/ministry.types";
import { AkcizneDozvoleDokumentiTipovi } from "../../../../../../../modules/obligee/exciseLicences/exciseLicences.constants";
import { ExciseLicencesContext } from "../../../../../../../modules/obligee/exciseLicences/exciseLicences.context";
import { exciseLicencesService } from "../../../../../../../modules/obligee/exciseLicences/exciseLicences.service";
import { DocumentApi } from "../../../../../../../types";
import { downloadFile } from "../../../../../../../utils/fileDownload";
import { toastService } from "../../../../../../../utils/toast.service";
import style from "./Document.module.scss";

interface IDocumentProps {
  documentType: AkcizneDozvoleDokumentiTipovi;
  data: IDozvolaZahteviDostavljeniDokaziProps | null;
  title: any;
  radioLabel?: string;
  radioLabel2?: string;
  dokumentName?: string;
  isAddDocumentDisabled?: boolean;
  availableFileSize: number;
  setAvailableFileSize: React.Dispatch<React.SetStateAction<number>>;
}

export const Document: React.FC<IDocumentProps> = ({
  documentType,
  data,
  title,
  dokumentName,
  setAvailableFileSize,
  availableFileSize,
}) => {
  const { setExciseLicences, exciseLicences, clearPayloadState } = useContext(
    ExciseLicencesContext
  );

  const { setError } = useContext(ModalsContext);

  const createDohvatiDokument = async () => {
    const [err, res] = await to(
      ministryService.createDohvatiDokument({ documentId: data?.id as any })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    toastService.success("TOAST.DOWNLOAD_SUCCESS");
    downloadFile(
      res.data.data,
      dokumentName || "dokument",
      res.data.format as any
    );
  };

  const handleUpload = (obj: DocumentApi, uid?: string, fileSize?: number) => {
    if (!uid || !fileSize) {
      return;
    }

    const newDokumenti = [
      ...exciseLicences.dokumentiZaDozvolu,
      { ...obj, dozvolaDocumentType: documentType, uid, fileSize },
    ];

    setAvailableFileSize((prev) => {
      const availableSize = prev - fileSize;

      if (availableSize < 0) {
        return prev;
      }

      return availableSize;
    });

    setExciseLicences({ dokumentiZaDozvolu: newDokumenti });
  };

  const handleRemove = (file: any) => {
    const fileForRemoval = exciseLicences.dokumentiZaDozvolu.find(
      (f) => (f.uid = file?.uid)
    );

    setExciseLicences({
      dokumentiZaDozvolu: exciseLicencesService.filterDokumentiZaDozvolu(
        exciseLicences.dokumentiZaDozvolu,
        file?.uid
      ),
    });

    setAvailableFileSize((prev) => {
      if (fileForRemoval?.fileSize) {
        const availableSize = prev - fileForRemoval.fileSize;

        if (availableSize < 0) {
          return prev;
        }

        return availableSize;
      }
      return prev;
    });
  };

  return (
    <div className={style.mainContainer}>
      <div className="pb-20">
        <span className={style.fontSize}>{title}</span>
      </div>
      <div className="pb-15">
        <FileUploader
          onUpload={handleUpload}
          onRemove={handleRemove}
          uploadButtonLabel={t("AKCIZNE_MARKICE.DODAJ")}
          maxFileSize={availableFileSize}
          disableIfUploaded
          showAvailableUploadSize
        />
      </div>
      {data && (
        <div
          className={style.documentTitle}
          onClick={() => createDohvatiDokument()}
        >
          {data?.dokumentUrl ? <DownloadOutlined /> : null}{" "}
          {data?.dokumentUrl || ""}
        </div>
      )}
    </div>
  );
};
